import { Fragment, useState } from "react";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";

export default function DeleteDialog({value}) {
   

  return (
    <Fragment>
    
    <Dialog open={value.showDeleteDialog} handler={value.handleMenu} className="min-w-[90%] md:min-w-[40%] border-main-color absolute top-0  "
     animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
    >
      <DialogHeader className="bg-main-color p-2 text-blue-gray-100  text-xl">حذف رکورد</DialogHeader>
      <DialogBody divider>
        {value.desc}
      </DialogBody>
      <DialogFooter className=" p-2">
        <Button
          variant="text"
          color="red"
          onClick={value.handleMenu}
          className="mr-1"
        >
          <span>Cancel</span>
        </Button>
        <Button className="bg-main-color" onClick={value.action}>
        تایـیـد
        </Button>
      </DialogFooter>
    </Dialog>
  </Fragment>
  )
}
